import React, { useRef, useState, useEffect } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import './ResizableImageComponent.css';

const ResizableImageComponent = ({ node, updateAttributes }) => {
  const imgRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);

  const startResize = () => setIsResizing(true);
  //const stopResize = () => setIsResizing(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing || !imgRef.current) return;
      const newWidth = e.clientX - imgRef.current.getBoundingClientRect().left;
      updateAttributes({ width: `${newWidth}px` });
    };

    const handleMouseUp = () => setIsResizing(false);

    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, updateAttributes]);

  return (
    <NodeViewWrapper
      className="resizable-image-wrapper"
      style={{ display: 'inline-block', position: 'relative' }}
    >
      <img
        ref={imgRef}
        src={node.attrs.src}
        alt={node.attrs.alt || ''}
        style={{
          width: node.attrs.width || 'auto',
          height: node.attrs.height || 'auto',
          maxWidth: '100%',
          display: 'block',
        }}
      />
      <div
        className="resize-handle"
        onMouseDown={startResize}
        style={{
          position: 'absolute',
          width: '12px',
          height: '12px',
          bottom: 0,
          right: 0,
          backgroundColor: '#3399ff',
          cursor: 'nwse-resize',
          borderRadius: '50%',
          zIndex: 10,
        }}
      />
    </NodeViewWrapper>
  );
};

export default ResizableImageComponent;